export const cc = [
    "Aryan Makhija",
    "Tashmit Verma",
    "Kaushal Singh",
    "Piyush Mohapatra",
    "Mahesh Chalamala",
    "Haswanth Reddy",
    "Ankit Kumar Chakraborty",
    "Shreyas Allani",
    "Kunta Sathvik Reddy",
    "Vishal Agarwal",
    "Yashvardhan Vijay",
    "Shobhit Singh",
    "Daksh Agiwal",
    "Sanghvi Prabhakar",
    "A Alfred Ruban",
    "Aditya Ojha",
    "Natarajan k",
    "K Sriyans",
    "Yash Mishra",
    "Shreya Sadhasivam",
    "Jyotsna Rani Kancheti",
    "Akshat Garg",
    "Shriya Hebbar",
    "Gaurav Gupta",
    "Komal Mathur",
    "Alok",
    "Srujana",
    "Rachit Prakash",
    "Aryan Gupta",
    "Ayush Sachan",
    "Anant Agarwal",
    "Ruthvik Avadhanam",
    "Muhsin Mehboob Chowdhury",
    "Sayantan Sett",
    "Shreyansh Tandon",
    "Aaditya Jain",
    "kartikey",
    "Sudibyo Sinha",
    "Nitin tiwari",
    "yaseen",
    "Aditya Aggarwal",
    "Shashank Kumar",
    "Peehu Yadav",
    "Prashast Saxena",
    "Shivli Mathur",
    "Shashank S Nayak",
    "Anushri Viraj Sakhardande",
    "Archit Agarwal",
    "Akshat singh",
    "Vittal Prabhu",
    "Anika Kauk",
    "tisha",
    "Diya Nair",
    "Sujal Ranjan",
    "Radhesh Pai",
    "Navya Jain",
    "Nikita Malik",
    "Kumud Rathore",
    "Ishan Parashar",
    "Aditi Sarraf",
    "Adruti Onam",
    "Prerna Mittal",
    "Vikas"
]